var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from "../../../constants/colors";
import Tooltip from "../../Atoms/Tooltip/Tooltip";
import { InfoIcon } from "../../Atoms/SayIcon/icons";
var TooltipInfoIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "16px" : _b, _c = _a.iconColor, iconColor = _c === void 0 ? "blue" : _c, rest = __rest(_a, ["size", "iconColor"]);
    var getColors = function () {
        switch (iconColor) {
            case "blue":
                return COLORS.SHADED_COBALT;
            case "black":
                return COLORS.BLACK;
            default:
                return iconColor;
        }
    };
    var color = getColors();
    return (_jsx(Tooltip, __assign({ tooltipColor: color, wrap: false }, rest, { children: _jsx(InfoIcon, { size: size, color: color }) })));
};
export default TooltipInfoIcon;
